module.exports = __webpack_public_path__ + "static/media/reliable-icon.a12572bd.svg";